<template>
  <div :class="$style.container">
    <VDropdown :shown="initiallyOpen">
      <CButton :class="buttonClasses" icon="chat_bubble_outline" />
      <span v-if="notificationsStore.unreadCount > 0" :class="counterClasses">
        {{ notificationsStore.unreadCount }}
      </span>
      <template #popper="{ hide }">
        <NotificationMessages :class="$style.popover" @close="hide" />
      </template>
    </VDropdown>
  </div>
</template>
<script setup lang="ts">
import { watch, ref, computed, useCssModule } from 'vue';
import { useNotificationsSetup } from '@/stores/notifications';
import NotificationMessages from './NotificationMessages.vue';

const props = withDefaults(
  defineProps<{
    variant?: 'light' | 'dark';
  }>(),
  { variant: 'light' }
);

const notificationsStore = useNotificationsSetup();

const params = new URLSearchParams(window.location.search);
const initiallyOpen = params.get('notifications') === 'true';
const hasReloaded = ref(false);

watch(
  () => notificationsStore.unreadCount,
  (count) => {
    if (!count) {
      hasReloaded.value = false;
      return;
    }
    hasReloaded.value = true;
    setTimeout(() => {
      hasReloaded.value = false;
    }, 1000);
  }
);

const style = useCssModule();
const buttonClasses = computed(() => {
  return {
    compact: true,
    white: props.variant === 'light',
    [style.dark]: props.variant === 'dark',
    [style.buttonHighlight]: hasReloaded.value,
  };
});

const counterClasses = computed(() => {
  return {
    [style.counter]: true,
    [style.counterHasNew]: hasReloaded.value,
  };
});
</script>
<style module>
.container {
  position: relative;

  .buttonHighlight {
    background-color: var(--amber-100);
  }

  .dark {
    --btn-color-bckg: transparent;
    --btn-border: 1px solid;

    &.buttonHighlight {
      background-color: var(--neutral-700);
    }
  }
}

.popover {
  display: grid;
  max-width: 26rem;
  max-height: 60vh;
  overflow-y: auto;
}

.counter {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 100%;
  width: 1.7em;
  height: 1.7em;
  background-color: var(--red-500);
  color: var(--neutral-50);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  border: 1px solid var(--neutral-50);
  transform: translate(25%, -25%);
  transition: all 0.5s;
}

.counterHasNew {
  font-size: 14px;
}
</style>
